import React, { FC, useEffect, useState } from "react";
import {
  Card,
  Select,
  Input,
  List,
  Tag,
  Row,
  Col,
  Button,
  Space,
  Typography,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import PatientCard from "./PatientCard";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Divider } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

dayjs.extend(customParseFormat);

const { Option } = Select;
const { Text } = Typography;

type PatientListProps = {
  allPatients: any[];
  visitType: any;
  scheme: any;
  search: any;
  dateRange: any;
  setVisitType: (visitType: any) => void;
  setScheme: (scheme: any) => void;
  setSearch: (search: any) => void;
  setDateRange: (dateRange: any) => void;
  schemes?: any[];
  fetchPatients: any;
  isFetchingPatients: boolean;
  isPreAuthSelected: boolean;
  setIsPreAuthSelected: any;
  fetchPatientsPending: any;
};

const PatientList: FC<PatientListProps> = ({
  allPatients,
  visitType,
  scheme,
  search,
  dateRange,
  setVisitType,
  setScheme,
  setSearch,
  setDateRange,
  schemes,
  fetchPatients,
  isFetchingPatients,
  isPreAuthSelected,
  setIsPreAuthSelected,
  fetchPatientsPending,
}) => {
  const { patients } = useSelector((state: RootState) => state);

  const handleApplyFilters = () => {
    if (!isPreAuthSelected) {
      fetchPatients();
    } else {
      fetchPatientsPending(patients?.visitStages["PreAuth"]?.id);
    }
  };

  return (
    <div
      style={{
        padding: 12,
        maxWidth: 480,
        margin: "0 auto",
        background: "#F1F8FF",
        minHeight: "100vh",
      }}
    >
      {/* ================= FILTER CARD ================= */}
      {/* <Card
        bordered={false}
        style={{
          borderRadius: 18,
          marginBottom: 22,
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
        bodyStyle={{ padding: 20 }}
      >
        <Text
          style={{
            fontSize: 16,
            fontWeight: 600,
            color: "#111827",
          }}
        >
          Filters
        </Text>

        <div style={{ marginTop: 16 }}>
          <Row gutter={[12, 12]}>
            <Col span={12}>
              <Select
                mode="multiple"
                placeholder="Visit Type"
                allowClear
                value={visitType}
                onChange={(value) => setLocalVisitType(value)}
                style={{ width: "100%" }}
                maxTagCount="responsive"
              >
                <Option value="OP">OP</Option>
                <Option value="IP">IP</Option>
                <Option value="EMERGENCY">Emergency</Option>
              </Select>
            </Col>
            <Col span={12}>
              <Select
                mode="multiple"
                placeholder="Scheme"
                allowClear
                value={scheme}
                onChange={(value) => setLocalScheme(value)}
                style={{ width: "100%" }}
                maxTagCount="responsive"
              >
                {schemes
                  ?.filter(
                    (s: any) =>
                      s.schemeMetaDataName === "CGHS NEW" ||
                      s.schemeMetaDataName === "ECHS",
                  )
                  ?.map((s: any) => (
                    <Option key={s.schemeMetaDataId} value={s.schemeMetaDataId}>
                      {s.schemeMetaDataName}
                    </Option>
                  ))}
              </Select>
            </Col>

            <Col span={12}>
              <Input
                placeholder="Search patient"
                allowClear
                prefix={<SearchOutlined />}
                value={search}
                onChange={(e) => setLocalSearch(e.target.value)}
              />
            </Col>
            <Col span={24}>
              <Button
                block
                onClick={handleApplyFilters}
                style={{
                  borderRadius: 12,
                  height: 46,
                  fontWeight: 600,
                  fontSize: 15,
                  background:
                    "linear-gradient(135deg, #0f766e 0%, #0d9488 100%)",
                  color: "#fff",
                  border: "none",
                }}
              >
                APPLY FILTERS
              </Button>
            </Col>
          </Row>
        </div>
      </Card> */}

      <Row
        gutter={[8, 8]}
        style={{
          //   background: "#f3f4f6",
          padding: 4,
          borderRadius: 14,
          width: "88vw",
        }}
      >
        {/* Line 1 → 3 Dropdowns */}
        <Col span={8}>
          <Select
            mode="multiple"
            className="filter-select"
            dropdownClassName="filter-select-dropdown"
            placeholder="SCHEME"
            size="small"
            bordered={false}
            value={scheme}
            onChange={(v) => setScheme(v)}
            style={{ width: "100%", fontSize: 10, background: "white" }}
            dropdownStyle={{ fontSize: 10 }}
            optionFilterProp="label"
          >
            {schemes
              ?.filter(
                (s: any) =>
                  s.schemeMetaDataName === "CGHS NEW" ||
                  s.schemeMetaDataName === "ECHS" ||
                  s?.schemeMetaDataName === "CAPF NEW",
              )
              ?.map((s: any) => (
                <Option
                  key={s.schemeMetaDataId}
                  value={s.schemeMetaDataId}
                  label={s.schemeMetaDataName}
                >
                  {s.schemeMetaDataName}
                </Option>
              ))}
          </Select>
        </Col>

        <Col span={8}>
          <Select
            mode="multiple"
            placeholder="CASE TYPE"
            size="small"
            className="filter-select"
            dropdownClassName="filter-select-dropdown"
            bordered={false}
            value={visitType}
            onChange={(v) => setVisitType(v)}
            style={{ width: "100%", fontSize: 10, background: "white" }}
          >
            <Option value="OP">OP</Option>
            <Option value="IP">IP</Option>
            <Option value="EMERGENCY">Emergency</Option>
          </Select>
        </Col>

        <Col span={8}>
          <Select
            placeholder="TODAY"
            size="small"
            className="filter-select"
            dropdownClassName="filter-select-dropdown"
            bordered={false}
            value={dateRange}
            onChange={(v) => setDateRange(v)}
            style={{ width: "100%", fontSize: 10, background: "white" }}
          >
            <Option value="today">Today</Option>
            <Option value="yesterday">Yesterday</Option>
            <Option value="last7days">Last 7 Days</Option>
          </Select>
        </Col>

        {/* Line 2 → Search + Apply */}
        <Col span={18}>
          <Input
            className="filter-search"
            placeholder="SEARCH"
            size="small"
            allowClear
            bordered={false}
            prefix={<SearchOutlined style={{ fontSize: 10 }} />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              fontSize: 10,
              borderRadius: 20,
              padding: "2px 8px",
              background: "white",
            }}
          />
        </Col>

        <Col span={6}>
          <Button
            size="small"
            className="filter-btn"
            block
            onClick={handleApplyFilters}
            style={{
              height: 24,
              borderRadius: 10,
              background: "#00395E",
              color: "#fff",
              border: "none",
              padding: 0,
            }}
          >
            APPLY
          </Button>
        </Col>
      </Row>

      <Divider style={{ margin: "8px 0" }} />

      {/* ================= PATIENT HEADER ================= */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ margin: "12px 0" }}>
          <span
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: "#111827",
            }}
          >
            Case Count
          </span>
          <span
            style={{
              marginLeft: 8,
              fontSize: 12,
              color: "#6b7280",
              border: "1px solid #2125291F",
              padding: "2px 8px",
              backgroundColor: "white",
              borderRadius: "5px",
            }}
          >
            {allPatients?.length || 0}
          </span>
        </div>
        <div
          style={{
            border: isPreAuthSelected
              ? "1px solid #004C8F"
              : "1px solid #D0D5DD",
            padding: "5px",
            borderRadius: "6px",
            width: "35%",
            background: isPreAuthSelected ? "white" : "none",
            textAlign: "center",
          }}
          onClick={() => setIsPreAuthSelected((prev: any) => !prev)}
        >
          <span
            style={{
              fontSize: 10,
              color: isPreAuthSelected ? "#004C8F" : "black",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            PreAuth Pending
          </span>
        </div>
      </div>

      {/* ================= PATIENT LIST ================= */}
      {allPatients?.length || isFetchingPatients ? (
        <List
          dataSource={allPatients}
          loading={isFetchingPatients}
          renderItem={(item: any) => (
            <PatientCard
              creditNumber={`${item?.schemeName}-${item.creditNumber}`}
              patientDetails={item}
              name={item.fullName}
              registrationNo={item.claimId}
              date={
                item?.doa
                  ? dayjs(item.doa, "DD-MM-YYYY HH:mm:ss").format("DD MMM, YY")
                  : "-"
              }
              type={item.visitType}
              uhid={item.uhidNo}
              primaryMobile={item?.primaryMobile}
            />
          )}
        />
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "70px 0",
            color: "#9ca3af",
          }}
        >
          <div style={{ fontSize: 42, marginBottom: 12 }}>📭</div>
          <div style={{ fontSize: 15, fontWeight: 500 }}>No Patients Found</div>
          <div style={{ fontSize: 13, marginTop: 6 }}>
            Try adjusting your filters
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientList;
